import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import './Contact.scss';
import { useEffect, useState, useRef } from 'react';
import BackIcon from '@/assets/rewise/back-icon.svg';
import { useGetContactList } from '../api/getContacts';
import { ArchiveIcon } from '@heroicons/react/outline';
import { Contact, UserRole, State } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';
import { Loader } from '@/components/Loader/Loader';
import noDataAnimation from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import Filter, { ReactComponent as FilterIcon } from '@/assets/steam/filter.svg';
import Delete from '@/assets/steam/delete.svg';
import View from '@/assets/steam/view.svg';
import Edit from '@/assets/steam/edit.svg';
import { TableData } from '@/components/Table/TableData';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import Utils from '@/utils/util';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import AddNewUser from '../components/editContact';
import { useGetStateList, useGetUserRoleList } from '../../users/api/getRefrences';
import { FilterMenu } from '@/components/Elements/FilterMenu';
import AddNewLocation from '../components/editContact';
import EditContact from '../components/editContact';
import { useDeleteContact } from '../api/deleteContact';
import SendMessage from '../components/sendMessageModal';
import ViewMessage from '../components/messagesDialog';
import { Institute } from '@/features/institute/types/indes';
import { useGetInstituteList } from '@/features/institute/api/getInstitute';

export const Contacts = () => {
  const [contactList, setContactList] = useState<Contact[]>([]);
  const [allContacts, setAllCountacts] = useState<Contact[]>([]);

  const [isAddNewContact, setIsAddNewContact] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableCurrentIndex, setTableCurrentIndex] = useState(1);
  const perPage = 10;
  const [searchString, setSearchString] = useState('');
  const [filteredList, setFilteredList] = useState<Contact[]>([]);
  const [productDetails, setProductDetails] = useState<Contact>();
  const useGetUsersMutation = useGetContactList();
  const useGetInstituteMutation = useGetInstituteList();
  const [roles, setRoles] = useState<UserRole[]>([]);
  const [states, setStates] = useState<State[]>([]);
  const [editContactData, setEditContactData] = useState<any>(null);
  const useGetUserRoleMutation = useGetUserRoleList();
  const useGetStateMutation = useGetStateList();
  const useDeleteUserMutation = useDeleteContact();
  const [filteredContactList, setFilteredContactList] = useState<Contact[]>([]);
  const [allInstituteList, setAllInstituteList] = useState<Institute[]>([]);
  const [selectedContactList, setSelectedContactList] = useState<number[]>([]);
  const [selectedContactListFormessaging, setSelectedContactListFormessaging] = useState<number[]>([]);
  const [selectedContact, setSelectedContact] = useState<any>();
  const [addMessageOnWp, setAddMessageOnWp] = useState(false);
  const [viewMessageDialog, setViewMessageDialog] = useState(false);

  useEffect(() => {
    getContactList(1, true);
    getAllContactList(1, true);
    getAllInstituteList(1, true);
    getUserRoleList();
    getStateList()
  }, []);

  const getUserRoleList = async () => {
    const res = await useGetUserRoleMutation.mutateAsync({
      search: ''
    });
    if (res) {
      setRoles(res.list);
    }
  };



  const getAllInstituteList = async (pageIndex: number, reset = false, filter?: any) => {
    const res = await useGetInstituteMutation.mutateAsync({
      page: pageIndex,
      perPage: 100,
      search: '',
      filter,
    });

    setAllInstituteList(res.list);
  };


  const getStateList = async () => {
    const res = await useGetStateMutation.mutateAsync({
      search: ''
    });
    if (res) {
      setStates(res.list);
    }
  };

  const getAllContactList = async (pageIndex: number, reset = false,) => {
    const res = await useGetUsersMutation.mutateAsync({
      page: pageIndex,
      perPage: 5000,
      search: '',
      filter: null,
    });

    setAllCountacts(res.list);
  };

  const getContactList = async (pageIndex: number, reset = false, filter?: any, isOnlyEdit?: any) => {
    const res = await useGetUsersMutation.mutateAsync({
      page: pageIndex,
      perPage: perPage,
      search: searchString,
      filter,
    });

    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
    if (isOnlyEdit) {
      setContactList(res.list);
      if (pageIndex) setTableCurrentIndex(pageIndex);
      if (searchString) {
        setFilteredList(res.list);
      }
    } else if (reset) {
      setSelectedContactList([]);
      setContactList(res.list);
      if (pageIndex) {
        setTableCurrentIndex(pageIndex);
      } else {
        setTableCurrentIndex(tableCurrentIndex);
      }
      if (searchString) {
        setFilteredList(res.list);
      }
    } else {
      setSelectedContactList([]);
      setContactList(contactList.concat(res.list));
      if (pageIndex) {
        setTableCurrentIndex(pageIndex);
      } else {
        setTableCurrentIndex(tableCurrentIndex);
      }
    }
  };

  const searchUser = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchString = e.target.value;
    setSearchString(searchString);
    const res = await useGetUsersMutation.mutateAsync({
      page: 1,
      perPage: perPage,
      search: searchString,
    });
    setContactList(res.list);
    if (searchString) {
      setFilteredList(res.list);
    } else {
      setFilteredList([]);
    }
    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
  };

  const actualList = filteredList.length ? filteredList : contactList;

  const onTableStateChange = (pageIndex: number) => {
    if (totalPages >= pageIndex) {
      getContactList(pageIndex, true);
    }
  };

  const deleteUser = async (id: any) => {
    const res = await useDeleteUserMutation.mutateAsync({
      id
    });
    if (res) {
      getContactList(tableCurrentIndex, true);
    }
  }
  const selectAllContacts = () => {
    const ContactListCurrent = filteredContactList.length ? filteredContactList : contactList;

    const currentPageContactIds = ContactListCurrent.map((contact: any) => parseInt(contact.id));

    if (currentPageContactIds.every((id) => selectedContactListFormessaging.includes(id))) {
      setSelectedContactList((prev) =>
        prev.filter((id) => !currentPageContactIds.includes(id))
      );
      setSelectedContactListFormessaging((prev) =>
        prev.filter((id) => !currentPageContactIds.includes(id))
      );
    } else {
      const newSelectedIds = currentPageContactIds.filter(
        (id) => !selectedContactListFormessaging.includes(id)
      );


      setSelectedContactList((prev) => [...prev, ...newSelectedIds]);
      setSelectedContactListFormessaging((prev) => [...prev, ...newSelectedIds]);
    }
  };





  const selectContact = (service: Contact) => {
    if (service?.id) {
      const filteredIndex = selectedContactList.indexOf(parseInt(service?.id));
      if (filteredIndex < 0) {
        selectedContactList.push(parseInt(service?.id));
      } else {
        selectedContactList.splice(filteredIndex, 1);
      }
      setSelectedContactList([...selectedContactList]);
    }
  };

  const selectContactForMesaaging = (service: Contact) => {
    if (service?.id) {
      const filteredIndex = selectedContactListFormessaging.indexOf(parseInt(service?.id));
      if (filteredIndex < 0) {
        selectedContactListFormessaging.push(parseInt(service?.id));
      } else {
        selectedContactListFormessaging.splice(filteredIndex, 1);
      }
      setSelectedContactListFormessaging([...selectedContactListFormessaging]);
    }
  };
  const messageThroughWati = () => {
    setAddMessageOnWp(true);
  }

  const resetData = () => {
    setSelectedContactList([]);
    setSelectedContactListFormessaging([]);
  }

  const areAllContactsSelectedForCurrentPage = () => {
    const ContactListCurrent = filteredContactList.length ? filteredContactList : contactList;

    const currentPageContactIds = ContactListCurrent.map((contact: any) => parseInt(contact.id));

    return currentPageContactIds.every((id) => selectedContactListFormessaging.includes(id));
  };

  return (
    <>

      <div className="users-list-container">
        <PageHeader title='Contact Management' description='' />
        <div className='search-container'>
          <div className='search-filter-container'>

            <span className="search-content">
              <SearchIcon />
              <input
                type="text"
                id="simple-search"
                placeholder="Search by Name, Email, Phone"
                onChange={searchUser}
                className="steam-search"
              />
            </span>
            <div>
              <div className="action-btn">
                <FilterMenu roles={roles} states={states} options={[]} onRoleSelect={(filter) => {
                  if (filter) {
                    getContactList(1, true, filter)
                  } else {
                    getContactList(1, true)
                  }
                }} showRoleFilter={false} />
              </div>
            </div>

          </div>
          <div className='add-user-container'>
            {selectedContactListFormessaging && selectedContactListFormessaging.length > 0 && <button className='steam-button button-dark' onClick={() => { messageThroughWati() }}>Send Message to {selectedContactListFormessaging?.length} Users</button>}

          </div>
        </div>
        <div className="users-list petsked-table">
          {useGetUsersMutation.isLoading && !searchString && (
            <div className="h-full w-full flex items-center justify-center  ">
              <Lottie className="loading-loader-class" animationData={noDataAnimation} />
            </div>
          )}

          <TableData<Contact>
            data={actualList}
            columns={[
              {
                title: 'Name',
                field: 'name',
                HeaderCell() {
                  return (
                    <label className="check-container" onClick={selectAllContacts}>
                      <span className="name"></span>
                      <input
                        type="checkbox"
                        defaultChecked={
                          areAllContactsSelectedForCurrentPage()}
                      />
                      <span className="checkmark"></span>
                    </label>
                  );
                },
                Cell({ entry }) {
                  return (
                    <div className="users-container">
                      <label
                        className={`check-container ${entry.id ? 'hide' : ''}`}
                        onClick={() => { selectContact(entry); selectContactForMesaaging(entry) }}
                      >
                        <input
                          type="checkbox"
                          defaultChecked={
                            entry &&
                              entry.id &&
                              selectedContactListFormessaging.indexOf(parseInt(entry?.id)) > -1
                              ? true
                              : false
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      <div>
                        <InitialsAvatar name={entry && entry.name ? entry.name : 'SA'} className="avatar" />
                      </div>
                      <div className="user-details-container">

                        <div className="user-tab-name ">
                          <div className="name">{entry?.name}  <span> {`(${entry?.phone})`}</span></div>
                          <div className="email">{entry?.email}  </div>
                        </div>
                      </div>
                    </div>
                  );
                },
              },
              {
                title: 'Institute Name',
                field: 'name',
                Cell({ entry: { institute } }) {
                  return (
                    <div className="table-user-role fixed-width">
                      {institute?.name}

                    </div>
                  );
                },
              },
              {
                title: 'State',
                field: 'name',
                Cell({ entry: { institute } }) {
                  return (
                    <div className="table-user-role fixed-width-100">{institute?.state?.name}
                    </div>
                  );
                },
              },
              {
                title: 'City',
                field: 'name',
                Cell({ entry: { institute } }) {
                  return (
                    <div className="table-user-role fixed-width-100">{institute?.city?.name}
                    </div>
                  );
                },
              },
              {
                title: 'Is Primary',
                field: 'name',
                Cell({ entry }) {
                  return (
                    <div className="table-user-role">
                      {entry?.isKeyPerson && <div className='addd-location is-primary'>
                        Primary
                      </div>}

                    </div>
                  );
                },
              },
              {
                title: 'Created At',
                field: 'name',
                Cell({ entry: { createdAt } }) {
                  return (
                    <div className="table-date">
                      {Utils.formatDate(
                        createdAt
                      )}
                    </div>
                  );
                },
              },

              {
                title: 'Action',
                field: 'id',
                Cell({ entry }) {
                  return (
                    <div className="user-btn-container">

                      <div
                        className="view-btn"
                        onClick={() => {
                          setSelectedContact(entry);
                          setViewMessageDialog(true);
                        }}
                      >
                        <img src={View} />
                      </div>
                      <div className="edit-btn" onClick={() => { setEditContactData(entry); setIsAddNewContact(true) }} >
                        <img src={Edit} />
                      </div>
                      <div className="edit-btn" onClick={() => { deleteUser(entry.id) }} >
                        <img src={Delete} />
                      </div>
                    </div>
                  );
                },
              },
            ]}
            tableInitialState={{
              tableTotalRecords: totalPages,
              tablePageIndex: tableCurrentIndex,
            }}
            onTableStateChange={onTableStateChange}
            showPagination={true}
            isDataLoading={useGetUsersMutation?.isLoading}
          />
        </div>
        <EditContact onConfirm={() => { resetData(); setIsAddNewContact(false); getContactList(tableCurrentIndex, false, null, true) }} onClose={() => { resetData(); setIsAddNewContact(false); setEditContactData(null) }} open={isAddNewContact} editContactData={editContactData} instituteList={allInstituteList} />
        <SendMessage allContacts={allContacts} open={addMessageOnWp} onConfirm={() => { resetData(); setAddMessageOnWp(false); getContactList(1, true) }} onClose={() => { resetData(); setAddMessageOnWp(false) }} selectedContact={selectedContactListFormessaging} onRemoveUser={(data: any) => { selectContact(data) }} />
        <ViewMessage open={viewMessageDialog} onConfirm={() => { resetData(); setSelectedContact(''), setViewMessageDialog(false); getContactList(1, true) }} onClose={() => { resetData(); setSelectedContact(''), setViewMessageDialog(false) }} selectedContact={selectedContact} onRemoveUser={(data: any) => { selectContact(data) }} />
      </div>

    </>
  );
};
